<template>
  <vs-table hover-flat v-if="categories && categories.length" :data="categories">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('category_name')"></vs-th>
      <vs-th v-text="$t('description')"></vs-th>
      <vs-th class="text-center" v-text="$t('function')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td :data-tr-title="$t('category_name')">
          <vs-input v-if="tr.edit" :placeholder="$t('category_name')" v-model="tr.title" class="w-full"/>
          <span v-else>{{ tr.title }}</span>
        </vs-td>
        <vs-td :data-tr-title="$t('description')">
          <vs-input v-if="tr.edit" :placeholder="$t('description')" v-model="tr.description" class="w-full"/>
          <span v-else>{{ tr.description }}</span>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <vs-button
              class="saveButton"
              :id="'updateCategoryButton' + tr.id"
              color="success"
              type="border"
              icon-pack="feather"
              icon="icon-save"
              size="small"
              @click="$emit('customClickSave', indextr, tr.id)" v-if="tr.edit == true"
            ></vs-button>&nbsp;
            <vs-button
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-x"
              size="small"
              @click="$emit('customClickCancel', indextr, tr.id)" v-if="tr.edit == true"
            ></vs-button>
            <vs-button
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-edit"
              size="small"
              @click="$emit('customClickEdit', indextr, tr.id)" v-if="tr.edit == false"
            ></vs-button>&nbsp;
            <vs-button
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash-2"
              size="small"
              @click="$emit('customClickDelete', indextr, tr.id)" v-if="tr.edit == false"
            ></vs-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Messages.Category.List',
  props: {
    categories: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">
  .table-messages-category-list {
    tr {
      th {
        &:nth-child(1) { width: 5%; }
        &:nth-child(2) { width: 40%; }
        &:nth-child(3) { width: 40%; }
        &:nth-child(4) { width: 15%; }
      }

      th,
      td {
        vertical-align: middle;
      }
    }
  }
</style>
